<style scoped lang="scss"></style>

<template>
  <ValidationProvider
    ref="provider"
    mode="eager"
    :vid="name"
    :name="validateAs"
    :rules="rules"
    :bails="false"
    v-slot="{ classes, errors }"
    tag="div"
    :class="{ 'opacity-75 cursor-not-allowed': disabled }"
  >
    <label v-if="label" :for="`id_${name}`" :class="[classes]" class="block w-full mb-4">
      {{ label }}
      <span v-if="(rules && typeof rules === 'string' && rules.includes('required')) || (typeof rules === 'object' && rules.required)">*</span>
    </label>

    <div class="flex flex-wrap gap-4" v-if="options">
      <div
        v-for="option in options"
        :key="`${option}_${render}`"
        @click="addOption(option)"
        :class="{ 'bg-primary-500 text-white': localValue && localValue[option] }"
        class="border border-gray-300 h-[54px] flex items-center justify-center rounded-12 px-4 hover:border-gray-300 transition-colors cursor-pointer emoji-word"
      >
        {{ $t(`${i18n}.${option}`) }}
      </div>
    </div>

    <span v-if="showError && errors[0]" class="text-red text-12 block mt-4">{{ errors[0] }}</span>
  </ValidationProvider>
</template>

<script lang="ts">
  import { Field as ValidationProvider } from "vee-validate";
  import { Component, Vue, Prop, Emit, Watch, Ref } from "vue-facing-decorator";

  @Component({
    components: {
      ValidationProvider,
    },
  })
  export default class FormBadgeSelect extends Vue {
    @Prop() name?: string;

    @Prop({ default: "forms.options" }) i18n?: string;

    @Prop({ default: () => {} }) value?: { [key: string]: boolean };

    @Prop() placeholder?: string;

    @Prop() rules?: string | object;

    @Prop() label?: string;

    @Prop() options?: [];

    @Prop({ default: true }) showError?: boolean;

    @Prop({ default: false }) disabled!: boolean;

    @Ref() readonly provider!: InstanceType<typeof ValidationProvider>;

    localValue: { [key: string]: boolean } = {};

    render = 0;

    private get validateAs(): string {
      if (this.label) {
        return this.label;
      }

      if (this.placeholder) {
        return this.placeholder;
      }

      if (this.name) {
        return this.name;
      }

      return `bade select field`;
    }

    private addOption(option: string) {
      if (!this.localValue) {
        this.localValue = {};
      }

      if (this.localValue[option]) {
        this.localValue[option] = false;
      } else {
        this.localValue[option] = true;
      }

      this.render++;
      this.handleInput();
    }

    @Emit("input")
    private handleInput(): { [key: string]: boolean } {
      return this.localValue;
    }

    @Watch("value", { immediate: true })
    private valueChanged(newValue: { [key: string]: boolean }) {
      if (typeof newValue !== "undefined") {
        this.localValue = newValue;
      }
    }
  }
</script>
